import React, { useState, useEffect } from 'react';

type NewTaskBtnProps = {
  handleAddTask: any,
}

const NewTaskBtn = ({ handleAddTask }: NewTaskBtnProps) => {
  const [isClicked, setIsClicked] = useState(false);
  const [taskTitle, setTaskTitle] = useState('');

  useEffect(() => {
    const listener: any = window.addEventListener('click', (e: any) => {
      if (e.target.getAttribute('id') !== 'addTask__btn') {
        setIsClicked(false);
      }
    });

    return () => {
      window.removeEventListener('click', listener);
    };
  }, []);

  const handleSubmit = (e: any) => {
    e.preventDefault();
    handleAddTask(taskTitle);
    setTaskTitle('');
    setIsClicked(false);
  };

  const handleTitleChange = (e: any) => setTaskTitle(e.target.value);

  return (
    <>
      {!isClicked && (
        <button type="button" onClick={() => setIsClicked(true)} id="addTask__btn" className="task__btn">
          <p id="addTask__btn">+ Add task</p>
        </button>
      )}
      {isClicked && (
        <form onSubmit={(e: any) => handleSubmit(e)}>
          <input
            id="addTask__btn"
            value={taskTitle}
            onChange={handleTitleChange}
            className="task__input"
            maxLength={40}
            type="text"
            placeholder="Enter task name" />
        </form>
      )}
    </>
  );
};

export default NewTaskBtn;
